import { Event } from '../Event'
import { ViewerContext } from '../../constants'
import { PathIntent } from './types'

export interface PathFlowCreatedEventProperties {
  path_intent: PathIntent
  source_key: string
  path_slug: string
  experiment_variation: string
  path_flow_id: string
  previous_path_flow_id?: string
}

export class PathFlowCreatedEvent extends Event<PathFlowCreatedEventProperties> {
  static displayName = 'Path Flow Created'

  static allowedViewerContexts = [ViewerContext.Consumer]
}
